export default __webpack_public_path__ + "static/portal-landing-7545655fc346c5ec56482f005156f9fc.png";